export function warenkorbBubbleUpdate(context) {
    context.dispatchEvent(new CustomEvent("warenkorb.update", { bubbles: true }))
}
export function warenkorbMerkzettelUpdate(context, artikelnummern) {
    context.dispatchEvent(new CustomEvent("artikel.in.warenkorb", { detail: { artikelnummern: artikelnummern }, bubbles: true }));
}